import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { getRoleInfo, setRoleInfo } from 'utils/auth';
import { getAwardRoles } from 'services/awardRoles';
import type { RoleInfo } from 'types/auth';

interface AwardRoleContextType {
  roleInfo: RoleInfo;
}

const AwardRoleContext = createContext<AwardRoleContextType>({
  roleInfo: {},
});

export const AwardRoleProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const [roleInfo, setRoleInfoState] = useState<RoleInfo>(() => getRoleInfo());

  const refreshAwardRoles = useCallback(async () => {
    try {
      const rolesData = await getAwardRoles();
      if (rolesData.data && rolesData.data.length > 0) {
        const roleData = rolesData.data[0];
        const newRoleInfo = {
          email: roleData.email,
          role_type: roleData.role_type,
          pillar: roleData.pillar,
          category: roleData.category,
        };
        setRoleInfoState(newRoleInfo);
        setRoleInfo(newRoleInfo);
      }
    } catch {
      // Silently fail — existing localStorage value remains
    }
  }, []);

  useEffect(() => {
    refreshAwardRoles();
  }, [location.pathname, refreshAwardRoles]);

  return (
    <AwardRoleContext.Provider value={{ roleInfo }}>
      {children}
    </AwardRoleContext.Provider>
  );
};

export const useAwardRole = () => useContext(AwardRoleContext);
